module.exports = __webpack_public_path__ + "static/media/4.2 Palamedesz Details Fahne_klein.5b4623df.jpg";